import { Box, Typography } from "@mui/material";
import { C, cardSx } from "../../theme/dashboardCardTokens";

// Same "icon chip + big number + label" stat tile as the admin dashboard's
// StatCardLight (pages/admin/Dashboard.js) — reused here so the
// patient/therapist dashboards read as one system with the rest of the app.
function StatCard({ icon, value, label }) {
  return (
    <Box
      sx={{
        ...cardSx,
        flex: "1 1 160px",
        minWidth: 160,
        p: "22px 24px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: "9px",
          background: C.gray7,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {icon}
      </Box>
      <Box>
        <Typography sx={{ fontSize: 30, fontWeight: 800, color: C.ink, letterSpacing: "-0.02em", lineHeight: 1.1 }}>
          {value}
        </Typography>
        <Typography sx={{ fontSize: 13, color: C.textSecondary, mt: "2px" }}>{label}</Typography>
      </Box>
    </Box>
  );
}

export default StatCard;
